import QrAction from '@/components/QrAction';
import {Alert, Container} from '@mui/material';
import type * as React from 'react';
import {useParams} from 'react-router-dom';

export const ValidActionItems = ['register', 'checkin', 'interested'];

const QrRegistrar = (): React.ReactElement => {
    const {actionItem} = useParams();
    const error = actionItem === undefined || !ValidActionItems.includes(actionItem);

    return (
        <Container maxWidth='sm'>
            {error && <Alert severity='error'>Action Item could not be found.</Alert>}
            {!error && <QrAction />}
        </Container>
    );
};

export default QrRegistrar;
